module.exports = __webpack_public_path__ + "img/coupon_tutorial_lalamee01.0e62513b.jpg";